import { render, staticRenderFns } from "./orderFormItemsView.vue?vue&type=template&id=af3c6ace&scoped=true&"
import script from "./orderFormItemsView.vue?vue&type=script&lang=js&"
export * from "./orderFormItemsView.vue?vue&type=script&lang=js&"
import style0 from "./orderFormItemsView.vue?vue&type=style&index=0&id=af3c6ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3c6ace",
  null
  
)

export default component.exports